import { Component, Input, OnInit } from '@angular/core';
import { UIRouter }                                      from '@uirouter/core';
import { TranslateService }                              from '@ngx-translate/core';

import { ApiService }      from '../../app-lite/api/api.service';
import { CodeTypeModel }   from '../../app-lite/core/models/code-type';
import { CustomerModel }  from '../../app-lite/customers/models/customer';
import { InvoiceModel }    from '../../app-lite/invoices/models/invoice';
import { Table }           from '../../app-lite/table/types/table';
import { TableColumn }     from '../../app-lite/table/types/table-column';
import { TableRowEvent }   from '../../app-lite/table/types/table-row-event';
import { TableService }    from '../../app-lite/table/table.service';

import { EditComponent }                 from '../../app-lite/table/cell-components/actions/edit.component';
import { InvoiceContactStatusComponent } from '../../app-lite/invoices/contact-status/invoice.contact-status.component';
import { InvoiceReferenceComponent }     from '../../app-lite/invoices/invoice.reference.component';

@Component({
  selector   : 'customer-invoices',
  template: require('./customer.invoices.html')
})
export class CustomerInvoicesComponent implements OnInit {
  @Input() customer: CustomerModel;
  @Input() invoices: InvoiceModel[];
  @Input() statusTypes: CodeTypeModel[];

  columns: TableColumn[];
  filtering: any = { begin_date: '', end_date: '', reference: '', status_type: '*' };
  showCustomerInvoices: boolean;
  tableCacheKey: string;
  tableSettings: Table;

  constructor (
    private apiService: ApiService,
    private tableService: TableService,
    private router: UIRouter,
    private translateService: TranslateService
  ) {}

  ngOnInit () {
    this.showCustomerInvoices = !!this.invoices.length;
    this.tableCacheKey        = 'customerInvoices';

    this.filtering = this.tableService.setFiltersFromCache(this.tableCacheKey, {
      begin_date : '',
      end_date   : '',
      reference  : '',
      status_type: '*'
    });

    this.columns = [
      {
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.REFERENCE')
        },
        component: {
          enabled: true,
          factory: InvoiceReferenceComponent
        } },
      {
        field : 'post_date',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'invoice_type',
        header: {
          text: this.translateService.instant('JS_SPACE.COLUMNS.TRAN_TYPE')
        },
        pipe: 'invoiceType'
      },
      {
        field : 'invoice_status',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'invoiceStatus'
      },
      {
        field : 'cash_or_account',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.TYPE')
        },
        pipe: 'customerType'
      },
      {
        field : 'total',
        header: {
          text: this.translateService.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        component: {
          enabled: true,
          factory: InvoiceContactStatusComponent
        },
        header: {
          classes: 'text-center',
          text   : this.translateService.instant('GENERAL_SPACE.STATUS.CONTACTED')
        },
        sortable: false
      },
      {
        classes: 'text-right',
        field  : 'balance_due',
        header : {
          classes: 'text-right',
          text   : this.translateService.instant('JS_SPACE.COLUMNS.BALANCE')
        },
        pipe: 'globalCurrency'
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: (event) => this.viewInvoice(event)
            }
          },
          enabled: !this.customer.archived,
          factory: EditComponent },
        sortable: false }
    ];

    this.tableSettings = {
      broadcast: 'filterInvoices',
      cache    : {
        enabled: true,
        key    : this.tableCacheKey
      },
      columns: this.columns,
      empty  : {
        text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND')
      },
      pagination: {
        enabled   : true,
        pageSize  : this.tableService.getCachedPaging(this.tableCacheKey).pageSize || 5,
        pageSizes : [ 5, 10, 25, 50 ],
        queryCount: () => this.apiService.get('/customers/invoice_count_with_find', [
          this.customer.id,
          this.filtering.status_type || '*',
          '*',
          this.filtering.begin_date || '*',
          this.filtering.end_date || '*',
          this.filtering.reference || '*'
        ])
      },
      rows: {
        highlight: {
          enabled: true
        }
      },
      sorting: this.tableService.setSortingFromCache(this.tableCacheKey, {
        direction: 'desc',
        field    : 'post_date'
      }) };
  }

  getInvoices ( params ): Promise<any> {
    return this.apiService.get('/customers/invoice_list_with_find', [
      this.customer.id,
      params.offset,
      params.pageSize,
      this.filtering.status_type || '*',
      '*',
      this.filtering.begin_date || '*',
      this.filtering.end_date || '*',
      params.field,
      params.direction,
      this.filtering.reference || '*'
    ]).then((invoices) => {
      this.invoices = invoices;

      return invoices;
    });
  }

  onRowDoubleClick ( event: TableRowEvent ): void {
    if ( !this.customer.archived ) {

      this.viewInvoice(event.row);

      };

    }

  viewInvoice ( invoice: InvoiceModel ): void {
    if (invoice.contains_vehicle_sale) {
      this.router.stateService.go('app.dealership.sale', {
        customer_id: this.customer.id,
        id         : invoice.id });
    }
    else {
      this.router.stateService.go('app.invoice', {
        customer_id: this.customer.id,
        id         : invoice.id,
        vehicle_id : invoice.vehicle_id
      });
    }
  }

  filterInvoices (): void {


    window['filterInvoices'](this.filtering);


    };


  }
